import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  icon?: ReactNode;
  className?: string;
}

function EmptyStateIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
      <path d="M8.5 10.5h5" />
      <path d="M8.5 13h3" />
    </svg>
  );
}

export function EmptyState({
  title,
  description,
  eyebrow = 'Ничего не найдено',
  action,
  children,
  icon,
  className,
}: EmptyStateProps) {
  return (
    <section
      className={`rounded-[28px] border px-5 py-6 text-center shadow-[0_18px_40px_rgba(26,26,26,0.04)] ${className ?? ''}`}
      style={{
        background: 'rgba(255, 248, 231, 0.96)',
        borderColor: 'rgba(0, 0, 0, 0.08)',
      }}
      role="status"
      aria-live="polite"
    >
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-[20px] bg-[#EDE8DC] text-[#6B4EE6]">
        {icon ?? <EmptyStateIcon />}
      </div>

      {eyebrow ? (
        <p className="mt-4 text-[12px] font-semibold uppercase tracking-[0.08em] text-[#6B6B6B]">
          {eyebrow}
        </p>
      ) : null}

      <h2 className="mt-2 text-xl font-semibold leading-7 text-[#1A1A1A]">{title}</h2>

      {description ? (
        <p className="mt-2 text-sm leading-6 text-[#6B6B6B]">{description}</p>
      ) : null}

      {children ? <div className="mt-4 text-sm leading-6 text-[#6B6B6B]">{children}</div> : null}

      {action ? <div className="mt-5 flex justify-center">{action}</div> : null}
    </section>
  );
}
